export enum SmokeballFirmProvisionStatusType {
    Pending = 0,
    SyncInitiated = 1,
    SyncComplete = 2,
    MappingInitiated = 3,
    MappingComplete = 4,
    Complete = 5,
    DoNotProvision = 6,
    Failed = 7
}

export function GetSmokeballFirmProvisionStatusType(smokeballProvisioningStatus: string): SmokeballFirmProvisionStatusType {

    if (!smokeballProvisioningStatus || smokeballProvisioningStatus.length === 0) {
        return SmokeballFirmProvisionStatusType.DoNotProvision;
    }

    switch (smokeballProvisioningStatus.toLocaleLowerCase()) {
        case 'pending':
            return SmokeballFirmProvisionStatusType.Pending;
        case 'complete':
            return SmokeballFirmProvisionStatusType.Complete;
        case 'syncinitiated':
            return SmokeballFirmProvisionStatusType.SyncInitiated;
        case 'synccomplete':
            return SmokeballFirmProvisionStatusType.SyncComplete;
        case 'mappinginitiated':
            return SmokeballFirmProvisionStatusType.MappingInitiated;
        case 'mappingcomplete':
            return SmokeballFirmProvisionStatusType.MappingComplete;
        case 'failed':
            return SmokeballFirmProvisionStatusType.Failed;
        default:
            return SmokeballFirmProvisionStatusType.DoNotProvision;
    }
}